import { render, staticRenderFns } from "./AlertAppDownload.vue?vue&type=template&id=4ea83fe2&scoped=true"
import script from "./AlertAppDownload.vue?vue&type=script&lang=js"
export * from "./AlertAppDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea83fe2",
  null
  
)

export default component.exports